import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltInlineReactionsSectionListWireframe from './VeltInlineReactionsSectionListWireframe/VeltInlineReactionsSectionListWireframe';
import VeltInlineReactionsSectionPanelWireframe from './VeltInlineReactionsSectionPanelWireframe/VeltInlineReactionsSectionPanelWireframe';
import VeltInlineReactionsSectionToolContainerWireframe from './VeltInlineReactionsSectionToolContainerWireframe/VeltInlineReactionsSectionToolContainerWireframe';
var VeltInlineReactionsSectionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-reactions-section-wireframe", __assign({}, transformedProps), children));
};
VeltInlineReactionsSectionWireframe.List = VeltInlineReactionsSectionListWireframe;
VeltInlineReactionsSectionWireframe.Panel = VeltInlineReactionsSectionPanelWireframe;
VeltInlineReactionsSectionWireframe.ToolContainer = VeltInlineReactionsSectionToolContainerWireframe;
export default VeltInlineReactionsSectionWireframe;
